import last from "lodash/last";

import { isStyleSectionContent } from "~/components/section/section-style/helpers";

export const getSectionRelatedSectionsQueueName = (fullSectionPath: string[]) => {
  if (fullSectionPath.length === 0) return;

  const getMagazinesStyleSubSectionRelatedQueueName = () => {
    if (fullSectionPath.length !== 4) return;
    if (!isStyleSectionContent(fullSectionPath)) return;

    return `section_categories_${fullSectionPath[2]}`;
  };

  return (
    getMagazinesStyleSubSectionRelatedQueueName() ?? `section_categories_${last(fullSectionPath)}`
  );
};
